module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "page-container"
  }, [_c('AbnormalContainers', {
    on: {
      "abnormal-containers-list": _vm.abnormalContainersList,
      "refresh-list": _vm.getAbnormalContainers
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28a70a63"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/alarm_manage/alarm_abnormal_containers.vue
// module id = 1389
// module chunks = 1